// Phase SA-5 — Outcome buttons (WON / LOST / PARTIAL / VOID / UNKNOWN).
//
// Replaces the legacy 5-radio outcome group with chip-style buttons
// per brief §4.1. Selected state uses outcome-specific tones from
// SA-3 (.sa-outcome-btn[data-selected="true"][data-outcome="..."]).

import type { DeclaredOutcome } from "../../slips/useSlipAutopsy.ts";
import { SLIP_OUTCOMES } from "./legHelpers.ts";

export interface OutcomeButtonsProps {
  value: DeclaredOutcome;
  onChange: (next: DeclaredOutcome) => void;
  /** Forwarded for nested-form a11y labelling. */
  ariaLabel?: string;
}

export function OutcomeButtons({
  value,
  onChange,
  ariaLabel = "Slip outcome",
}: OutcomeButtonsProps): JSX.Element {
  return (
    <div
      className="sa-outcome-buttons"
      role="radiogroup"
      aria-label={ariaLabel}
      data-testid="sa-outcome-buttons"
    >
      {SLIP_OUTCOMES.map((o) => {
        const selected = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            className="sa-outcome-btn"
            data-outcome={o.value}
            data-selected={selected || undefined}
            data-testid={`sa-outcome-${o.value}`}
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(o.value)}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
